import { forwardRef, type JSX } from 'react';
import type { PolymorphicRef, PolymorphicComponentPropWithRef } from '../types';
import styles from './screen-reader-only.module.css';
import clsx from 'clsx';

export type ScreenReaderOnlyProps<As extends React.ElementType = 'span'> =
  PolymorphicComponentPropWithRef<As>;

const ScreenReaderOnlyComp = <As extends React.ElementType = 'span'>(
  { as, className, ...rest }: ScreenReaderOnlyProps<As>,
  ref: PolymorphicRef<As>
) => {
  const Tag = as || 'span';
  return <Tag className={clsx(styles.srOnly, className)} ref={ref} {...rest} />;
};

export const ScreenReaderOnly = forwardRef<null>(ScreenReaderOnlyComp) as <
  As extends React.ElementType = 'span'
>(
  props: ScreenReaderOnlyProps<As>
) => JSX.Element;

(ScreenReaderOnly as React.FC).displayName = 'ScreenReaderOnly';
